import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../../assets/svg/close-modal.svg";
import { Row, Col } from "react-bootstrap";
// import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import CommonAsyncSelect from "../../common/custom-select";
import { getCustomerApi, getDeptApi, getLocationApi, getProductTypeApi, getProductTypesApi, getTransporterApi, saveProductApi, saveTransporterApi, updateProductApi, updateTransporterApi } from "../customers/customer-api";
import "../customers/customer.css";
const ProductCreateModal = ({ povId, onSuccess, onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [validations, setValidations] = useState({
        code: "",
        name: "",
        email: "",
        contact_number: "",
        locations: "",
        departments: "",
    });
    useEffect(() => {
        if (povId != null) {
            getProductTypeDetails();
        }
    }, [povId])

    const getProductTypeDetails = async () => {
        const response = await getProductTypesApi(povId);
        if (response.status === 200) {
            if (response.data.success === true) {
                setName(response.data.product_type.name ?? '');
                setCode(response.data.product_type.code ?? '');
                setSelectedLocation(response.data.product_type.locations ?? [])
                setSelectedDept(response.data.product_type.departments ?? [])

            }
        }
    }
    const [locationsOptions, setlocationsOptions] = useState(null);
    const [multipleGatein, setmultipleGatein] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedDept, setSelectedDept] = useState([]);
    const handleAssignToDropdownChange = (selectedOptions) => {
        console.log(selectedOptions);
        setlocationsOptions(selectedOptions);
    };
    const modalStyle = {
        overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
        modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", overflowY: "auto", minHeight: "fit-content" },
    };

    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contactNo, setcontactNo] = useState("");


    const getLocationData = (inputValue, callback) => {
        setTimeout(async () => {
            console.log("Fetching transport options with term:", inputValue);
            const response = await getLocationApi(inputValue);
            if (response.status === 200) {
                if (response.data.success === true) {
                    const options = response.data.suggestionlist.map((item) => ({
                        value: String(item.value),
                        label: String(item.label),
                    }));
                    callback(options);
                }
            }
        }, 1000);
    };
    const getDepartmentData = (inputValue, callback) => {
        setTimeout(async () => {
            console.log("Fetching transport options with term:", inputValue);
            const response = await getDeptApi(inputValue);
            if (response.status === 200) {
                if (response.data.success === true) {
                    const options = response.data.suggestionlist.map((item) => ({
                        value: String(item.value),
                        label: String(item.label),
                    }));
                    callback(options);
                }
            }
        }, 1000);
    };











    const handleLocationChange = (selectedOptions) => {
        console.log(selectedOptions);
        setSelectedLocation(selectedOptions);
    };
    const handleDeptChange = (selectedOptions) => {
        console.log(selectedOptions);
        setSelectedDept(selectedOptions);
    };
    const saveProduct = async () => {
        try {
            const payload = {
                "code": code,
                "name": name,
                "locations": selectedLocation.map(item => item.value),
                "departments": selectedDept.map(item => item.value),
            };
            const dataAfterSanitize = {};
            Object.entries(payload).forEach(([key, value]) => {
                if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
                    dataAfterSanitize[key] = value;
                } else {
                    dataAfterSanitize[key] = DOMPurify.sanitize(value);
                }
            });
            let response;
            if (povId === null) {
                response = await saveProductApi(dataAfterSanitize);
            } else {
                response = await updateProductApi(dataAfterSanitize, povId);
            }


            console.log('response', response);
            if (response.status === 400) {
                const validationTemp = {
                    code: "",
                    name: "",
                    locations: "",
                    departments: "",
                };

                // Safely iterate over the errors and pick the first message if available
                if (response.data?.error) {
                    Object.entries(response.data.error).forEach(([key, value]) => {
                        // Make sure value is an array and has at least one item
                        validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : '';
                    });
                }

                setValidations(validationTemp);
            } else {

            }

            if (response.data.success === true) {
                onSuccess(response.data)
            }


        } catch (err) {
            console.error("Error fetching category:", err);
        }
    };

    return (
        <div style={modalStyle.overlay}>
            <div style={modalStyle.modal}>
                <div style={{ color: "#ffffff" }}>
                    <div className="modal-header style-justify-between">
                        <div className="add-item-modal-title">{povId != null ? "Edit " : "Add "} Product Type</div>
                        <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
                    </div>
                    <div style={{ padding: "16px 24px" }}>
                        <Row style={{ width: "670px" }}>
                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Code<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                                <span className="field-error">{validations.code}</span>
                            </Col>

                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Product Name<span style={{ color: "#FF4444" }}>*</span>
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
                                <span className="field-error">{validations.name}</span>
                            </Col>

                            {/* <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Mobile Number
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={contactNo} onChange={(e) => setcontactNo(e.target.value)} />
                                <span className="field-error">{validations.contact_number}</span>
                            </Col>

                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Email
                                </div>
                                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={email} onChange={(e) => setEmail(e.target.value)} />
                                <span className="field-error">{validations.email}</span>
                            </Col> */}
                            
                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Location
                                    {/* <span style={{ color: "#FF4444" }}>*</span> */}
                                </div>
                                <CommonAsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" />
                                <span className="field-error">{validations.locations}</span>
                            </Col>

                            <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                                <div className="field-title">
                                    Department
                                    {/* <span style={{ color: "#FF4444" }}>*</span> */}
                                </div>
                                <CommonAsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select department" />
                                <span className="field-error">{validations.departments}</span>
                            </Col>
                        </Row>

                        <Row className="mt-3" style={{ width: "670px" }}>
                            <div className="style-justify-end">
                                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                                    Cancel
                                </div>
                                <div className="save-modal-btn style-justify-center" onClick={() => saveProduct()}
                                >
                                    {povId != null ? "Update " : "Save "}
                                </div>
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductCreateModal;
